import { render, staticRenderFns } from "./iframePage.vue?vue&type=template&id=a8f28cec&scoped=true"
import script from "./iframePage.vue?vue&type=script&lang=js"
export * from "./iframePage.vue?vue&type=script&lang=js"
import style0 from "./iframePage.vue?vue&type=style&index=0&id=a8f28cec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f28cec",
  null
  
)

export default component.exports